import React from 'react'
import PatientView from '../../patients/components/PatientView';

function PatientPortalProfilePage() {
  return (
  <PatientView isPatientPortal={true}/>
  )
}

export default PatientPortalProfilePage;